/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable unused-imports/no-unused-vars */
import React, { useState, useMemo, useEffect, useRef, useCallback } from "react";

import { IconButton, Paper, Modal, Box, Tooltip, Grid } from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import { colors } from "@zapalacorp/tokens";
import { Button } from "Components/Form";
import { Color } from "Components/Form/Button";
import { TextButton } from "Components/Generic";
import ActionButtons from "Components/Generic/ActionButtons";
import ConfirmDeleteModal from "Components/Generic/ConfirmDeleteModal/ConfirmDeleteModal";
import { NotificationToast } from "Components/Generic/Toast/NotificationToast";
import { PRIVATE_ROUTES } from "Constants";
import _, { filter } from "lodash";
import { Searches } from "Models/shipeezi.table";
import { ISubscriber } from "Models/shipments";
import { useTranslation } from "react-i18next";
import { FaPlus } from "react-icons/fa6";
import { FiTrash2, FiX } from "react-icons/fi";
import { useHistory } from "react-router-dom";
import { ReactSVG } from "react-svg";
import { v4 as uuid } from "uuid";
import * as yup from "yup";

import { useActions } from "../../../hooks/useAction";
import { useShipmentContext } from "../../hooks/useContext";
import ModalSendCommunication from "../ModalSendCommunication/ModalSendCommunication";
import { EmptySection } from "../Orders/Empty";
import ShipmentNewSubscriberForm from "./components/ShipmentNewSubscriberForm";
import { useWaybillNotificationGridConfig } from "./hooks/WaybillNotifications.hook";
import { IFormValues, WaybillNotificationsProps } from "./interface/WaybillNotifications.interface";
import { CustomerDetails } from "Models/shipments/shipments.tracking";
import {
  ContentContainer,
  ContentWrapper,
  StyledListItemButton,
  StyledDrawerTitle,
} from "./styles";
import { validationSchema } from "./utils/WaybillNotifications.utils";
import WaybillNotificationService from "./WaybillNotifications.service";
import { Job } from "Models/job";
import { SubscriberPatchModeEnum } from "./enum/WaybillNofitications.enum";
import ShipeeziNewGrid, { Column, GeneralActions } from "Components/AppGrid/shipeezi-new-grid";
import lodash from "lodash";
import { Divider } from "semantic-ui-react";
import { he } from "date-fns/locale";
import { height } from "../../../../../../../translate/locales/en_US";
import { borderColor, borderRadius } from "@mui/system";
import { ShipmentTrackingStatus } from "Util/enums";
import { Customer } from "Models/customer";
import useStyles from "./styles";

const ACTION_COMMUNICATION_ICON = require("Assets/icons/action-communication-icon.svg");
const EditIcon = require("Assets/icons/edit.svg");
const SendMessageIcon = require("Assets/icons/send-2.png");
const DeleteIcon = require("Assets/icons/trash.svg");
const SHOW_ALL_ORDER_ID = "Show all";

export const WaybillNotificationsTab: React.FC<WaybillNotificationsProps> = (
  props: WaybillNotificationsProps
) => {
  const [isShowConfirmDelete, setIsShowConfirmDelete] = useState(false);
  const [processedItem, setProcessedItem] = useState<ISubscriber | null>(null);
  const { t: translate } = useTranslation();
  const history = useHistory();
  const componentHeight = useMemo(() => "calc(100vh - 395px)", []);
  const gridHeight = useMemo(() => "495px", []);
  const { shipment, setShipment, agents, isLoading, hasUnsavedChanges, setHasUnsavedChanges } =
    useShipmentContext();

  const { useDeleteShipmentSubscriber, useUpdateShipmentSubscriber, useAddShipmentSubscriber } =
    useActions();
  const [
    { total, filters, sorting, page, pageSize, pageSizeOptions, selectedRowList },
    { setPage, setPageSize, setSelectedRowList, handleSorting },
  ] = useWaybillNotificationGridConfig();
  const {
    mutate: deleteShipmentSubscriber,
    isLoading: isDeleting,
    error: deleteError,
    isSuccess: isDeleted,
  } = useDeleteShipmentSubscriber();
  const {
    mutate: updateShipmentSubscriber,
    isLoading: isUpdating,
    error: updateError,
    isSuccess: isUpdated,
  } = useUpdateShipmentSubscriber();
  const [isComponentPristine, setIsComponentPristine] = useState(true);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [gridState, setGridState] = useState({});
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedOrder, setSelectedOrder] = useState<{ label: string; value: string }>({
    value: SHOW_ALL_ORDER_ID,
    label: SHOW_ALL_ORDER_ID,
  });
  const classes = useStyles();
  const [isNewSubscriberModalOpen, setIsNewSubscriberModalOpen] = useState(false);
  const [newSubscriberFormErrors, setNewSubscriberFormErrors] = useState<any>(undefined);
  const getSubscribersLinkingToOrders = useCallback(
    (
      jobs: Job[],
      originSubscribersMap: Map<number, any>,
      customersToShipment?: CustomerDetails[]
    ) => {
      let customerAcc: ISubscriber[] = [];

      if (customersToShipment?.length) {
        const customers = customersToShipment?.map(
          ({ customer, order }) =>
            ({
              id: customer?.id || uuid(),
              name: customer?.name,
              lastName: customer?.lastName || "",
              fullName: customer?.fullName || `${customer?.name} ${customer?.lastName || ""}`,
              email: customer?.email,
              phone: customer?.phone,
              mobile: customer?.phone || customer?.mobile,
              jobReference: order,
            } as any)
        );

        if (customers?.length) {
          customerAcc = customers.reduce((acc: ISubscriber[], customer: any) => {
            const existingSubscriber = originSubscribersMap?.get(customer.id!);

            if (!existingSubscriber || !customer.id) {
              acc.push({
                id: customer.id!,
                firstName: customer?.name || "",
                fullName: customer?.fullName || `${customer?.name} ${customer?.lastName || ""}`,
                lastName: customer?.lastName || "",
                shipmentId: shipment?.id || undefined,
                mode: SubscriberPatchModeEnum.ClientSnapShot,
                email: customer?.email,
                contactType: translate("customer"),
                customerId: customer?.id,
                isLinkToOrder: true,
                jobReference: customer.jobReference,
                mobile: customer?.mobile || customer?.phone,
                notifyViaEmail: !!customer?.email,
                notifyViaSms: !!customer?.mobile || !!customer?.phone,
                isNew: true,
              });
            }
            return acc;
          }, []);
        }
      }

      const jobsAcc = jobs?.reduce((acc: ISubscriber[], job: Job) => {
        const customer = job?.customer;
        const moveCoordinator = job?.moveCoordinator;
        const manager = job?.manager;
        const bookingAgent = job?.bookingAgent;
        const consultant = job?.user;
        const isEntityIdExisted = (id: number) =>
          originSubscribersMap?.size > 0 && !_.isEmpty(originSubscribersMap?.get(id));
        // To check if the process data is existed in the origin subscribers data set. if not existed --> pass this item into the list as a new item

        if (customer && customer?.id && !isEntityIdExisted(customer.id)) {
          acc?.push({
            id: customer?.id,
            firstName: customer?.name || "",
            fullName: customer?.fullName || "",
            shipmentId: shipment?.id || undefined,
            mode: SubscriberPatchModeEnum.ClientSnapShot,
            lastName: customer?.lastName || "",
            email: customer?.email,
            contactType: translate("customer"),
            customerId: customer?.id,
            isLinkToOrder: true,
            jobReference: job.reference,
            mobile: customer?.mobile || moveCoordinator?.phone || "",
            notifyViaEmail: !!customer?.email,
            notifyViaSms: !!customer?.mobile || !!moveCoordinator?.phone,
            isNew: true,
          });
        }
        if (moveCoordinator && moveCoordinator?.id && !isEntityIdExisted(moveCoordinator.id)) {
          acc?.push({
            id: moveCoordinator?.id,
            firstName: moveCoordinator?.name || "",
            fullName: moveCoordinator?.fullName || "",
            shipmentId: shipment?.id || undefined,
            email: moveCoordinator?.email,
            mode: SubscriberPatchModeEnum.ClientSnapShot,
            lastName: moveCoordinator?.lastName || "",
            isLinkToOrder: true,
            contactType: translate("moveCoordinator"),
            typeUser: translate("moveCoordinator"),
            moveCoordinatorId: moveCoordinator?.id,
            jobReference: job.reference,
            mobile: moveCoordinator?.phone || "",
            notifyViaEmail: !!moveCoordinator?.email,
            notifyViaSms: !!moveCoordinator?.phone,
            isNew: true,
          });
        }

        if (manager && manager?.id && !isEntityIdExisted(manager.id)) {
          acc?.push({
            id: manager?.id,
            firstName: manager?.name || "",
            fullName: manager?.fullName || "",
            lastName: manager?.lastName || "",
            shipmentId: shipment?.id || undefined,
            isLinkToOrder: true,
            email: manager?.email,
            mode: SubscriberPatchModeEnum.ClientSnapShot,
            contactType: translate("manager"),
            typeUser: translate("manager"),
            managerId: manager?.id,
            jobReference: job.reference,
            mobile: manager?.mobile || manager?.phone || "",
            notifyViaEmail: !!manager?.email,
            notifyViaSms: !!manager?.mobile || !!manager?.phone,
            isNew: true,
          });
        }
        if (bookingAgent && bookingAgent?.id && !isEntityIdExisted(bookingAgent.id)) {
          acc?.push({
            id: bookingAgent?.id,
            firstName: bookingAgent?.name || "",
            fullName: bookingAgent?.fullName || "",
            mode: SubscriberPatchModeEnum.ClientSnapShot,
            email: bookingAgent?.email,
            lastName: bookingAgent?.lastName || "",
            shipmentId: shipment?.id || undefined,
            contactType: translate("bookingAgent"),
            typeUser: translate("bookingAgent"),
            bookingAgentId: bookingAgent?.id,
            isLinkToOrder: true,
            jobReference: job.reference,
            mobile: bookingAgent?.mobile || bookingAgent?.phone || "",
            notifyViaEmail: !!bookingAgent?.email,
            notifyViaSms: !!bookingAgent?.mobile || !!bookingAgent?.phone,
            isNew: true,
          });
        }
        if (consultant && consultant?.id && !isEntityIdExisted(consultant.id)) {
          acc?.push({
            id: consultant?.id,
            firstName: consultant?.name || "",
            fullName: consultant?.fullName || "",
            lastName: consultant?.lastName || "",
            shipmentId: shipment?.id || undefined,
            isLinkToOrder: true,
            mode: SubscriberPatchModeEnum.ClientSnapShot,
            email: consultant?.email,
            contactType: translate("consultant"),
            typeUser: translate("consultant"),
            consultantId: consultant?.id,
            jobReference: job.reference,
            mobile: consultant?.phone || "",
            notifyViaEmail: !!consultant?.email,
            notifyViaSms: !!consultant?.phone,
            isNew: true,
          });
        }
        return acc;
      }, []);

      return [...jobsAcc, ...customerAcc];
    },
    []
  );

  const subscribersDirectFromOrder = useMemo(() => {
    return getSubscribersLinkingToOrders(
      shipment?.jobs || [],
      new Map(),
      shipment?.customersToShipment || shipment?.customers
    );
  }, [shipment?.jobs, shipment?.subscribers, shipment?.customersToShipment, shipment?.customers]);

  const handleRemoveSubscribers = useCallback(async (removedSubscribers: ISubscriber[]) => {
    if (!removedSubscribers?.length) return;

    try {
      await Promise.all(
        removedSubscribers.map((subscriber: ISubscriber) => {
          const id = subscriber?.id;
          if (id) {
            return new Promise((resolve, reject) => {
              deleteShipmentSubscriber(id?.toString(), {
                onSuccess: () => resolve(true),
                onError: reject,
              });
            });
          }
          return Promise.reject();
        })
      );

      // After all subscribers are removed, refetch the data
      refetchSubscribers();
    } catch (error) {
      NotificationToast.error(translate("anErrorOccurredTryAgain"));
    }
  }, []);
  const handleAddSubscribers = useCallback(async (addedSubscribers: ISubscriber[]) => {
    if (!addedSubscribers?.length) return;

    try {
      await Promise.all(
        addedSubscribers.map(
          (subscriber) =>
            new Promise((resolve, reject) => {
              const cloneSubscriber = _.cloneDeep(subscriber);
              if (cloneSubscriber?.id) {
                delete cloneSubscriber.id;
              }

              addSubscriber(cloneSubscriber, {
                onSuccess: () => resolve(true),
                onError: reject,
              });
            })
        )
      );

      // After all subscribers are added, refetch the data
      refetchSubscribers();
    } catch (error) {
      console.error("Error adding subscribers:", error);
      NotificationToast.error(translate("anErrorOccurredTryAgain"));
    }
  }, []);

  const formValueRef = useRef<any>({});
  const [isOpenModalSendCommunication, setIsOpenModalSendCommunication] = useState<boolean>(false);

  const searchParams = useMemo(
    () => (searchQuery ? [{ query_keywords: searchQuery }] : {}),
    [searchQuery]
  );

  const {
    data: fetchedSubscribers,
    isFetching: isFetchingSubscribers,
    refetch: refetchSubscribers,
  } = useQuery({
    queryKey: [
      "shipment.notifications.subscribers",
      shipment?.id,
      searchQuery,
      selectedOrder?.value,
      searchParams,
      sorting,
    ] as const,
    queryFn: () =>
      WaybillNotificationService.getSubscribers(
        shipment?.id || 0,
        page!,
        rowsPerPage,
        selectedOrder?.value !== SHOW_ALL_ORDER_ID && selectedOrder?.value
          ? selectedOrder?.value
          : "",
        searchParams,
        sorting
      ),
    enabled: !!shipment?.id && (!!searchParams || !!selectedOrder?.value),
    select: (response: any) => {
      return (
        response?.data?.map((subscriber: any) => ({
          ...subscriber,
          fullName: `${subscriber?.firstName} ${subscriber?.lastName}`,
        })) || []
      );
    },
  });

  const { mutate: addSubscriber, isLoading: isAdding } = useAddShipmentSubscriber();

  const validateForm = async (values: IFormValues | any) => {
    try {
      validationSchema.validateSync(values, { abortEarly: false });
      setNewSubscriberFormErrors([]);

      return true;
    } catch (error) {
      if (error instanceof yup.ValidationError) {
        setNewSubscriberFormErrors(error.inner);

        return false;
      }
      console.error("Error adding subscriber:", error);

      return false;
    }
  };

  const handleFormChange = (values: any) => {
    formValueRef.current = {
      ...formValueRef.current,
      ...values,
    };
  };

  const handleAddSubscriberDuringEditionMode = async (subscriber: any) => {
    try {
      const updateSubscriber = _.cloneDeep(subscriber);
      delete updateSubscriber.id;

      addSubscriber(
        { ...updateSubscriber, shipmentId: shipment?.id },
        {
          onSuccess: () => {
            refetchSubscribers();
          },
        }
      );
    } catch {
      NotificationToast.error(translate("anErrorOccurredTryAgain"));
    }
  };

  const handleAddSubscriber = async () => {
    if (_.isEmpty(formValueRef.current)) {
      return;
    }

    const isFormValid = await validateForm(formValueRef.current!);

    if (!isFormValid) return;

    const newSubscriber = {
      ...formValueRef.current,
      isNew: true,
      fullName: `${formValueRef.current?.firstName || formValueRef.current?.name} ${
        formValueRef.current?.lastName
      }`,
    };
    if (shipment?.id) {
      handleAddSubscriberDuringEditionMode({ ...newSubscriber });
    } else {
      const updatedShipment = {
        ...shipment,
        subscribers: [
          ...(shipment?.subscribers || []),
          { ...newSubscriber, id: newSubscriber?.id || uuid() },
        ],
      } as any;

      setShipment(updatedShipment);
    }
    setIsNewSubscriberModalOpen(false);
    formValueRef.current = {};
    setProcessedItem(null);
    setGridState({});
    setPage?.(0);
    NotificationToast.success(translate("subscriberSuccessfullyAdded"));
  };

  const handleEditSubscriber = async () => {
    if (_.isEmpty(formValueRef.current)) {
      return;
    }
    const isFormValid = await validateForm(formValueRef.current!);

    if (!isFormValid) return;
    if (shipment?.id) {
      updateShipmentSubscriber(
        {
          subscriberId: formValueRef.current?.id!,
          subscriber: formValueRef.current!,
        },
        {
          onSuccess: () => {
            refetchSubscribers();
          },
        }
      );
    } else {
      const existedSubscriber = shipment?.subscribers?.find(
        (subscriber) => subscriber.id === formValueRef.current?.id
      );

      const updatedSubscriber = {
        ...existedSubscriber,
        ...formValueRef.current,
      };
      const updatedShipment = {
        ...shipment,
        subscribers: shipment?.subscribers?.map((subscriber) =>
          subscriber.id === formValueRef.current?.id ? updatedSubscriber : subscriber
        ),
      } as any;

      setShipment(updatedShipment);
    }
    setIsNewSubscriberModalOpen(false);
    setGridState({});
    setPage?.(0);
    formValueRef.current = {};
    setProcessedItem(null);
  };

  const removeSubscriber = async (removedSubscriber: ISubscriber) => {
    try {
      deleteShipmentSubscriber(String(removedSubscriber.id), {
        onSuccess: () => {
          refetchSubscribers();
        },
      });

      setSelectedRowList?.((prev: any) =>
        prev?.filter((item: any) => item?.id! !== removedSubscriber?.id!)
      );
      setProcessedItem(null);
    } catch {
      NotificationToast.error(translate("anErrorOccurredTryAgain"));
    }
  };

  const isSelected = (id: any) => {
    return !!selectedRowList?.find((item: any) => item?.id === id);
  };

  const columns: Column[] = [
    {
      name: "contactType",
      title: translate("typeOfContact"),
      hideSort: true,
      hideSearch: true,
    },
    {
      name: "firstName",
      title: translate("name"),
      hideSort: true,

      formatComponent: (value: any, params: any) => {
        return <div>{params?.fullName || ""}</div>;
      },
    },
    {
      name: "email",
      hideSort: true,
      title: translate("email"),
    },
    {
      name: "mobile",
      hideSort: true,
      title: translate("phoneNumber"),
    },
    {
      name: "notifyVia",
      hideSearch: true,

      hideSort: true,
      title: translate("notifyVia"),
      formatComponent: (value: any, params: ISubscriber) => {
        const notifyMethods = [];
        if (params.notifyViaEmail) notifyMethods.push("E-mail");
        if (params.notifyViaSms) notifyMethods.push("SMS");

        return <span>{notifyMethods.length > 0 ? notifyMethods.join(", ") : ""}</span>;
      },
    },
  ];

  const subscribers = useMemo(() => {
    const subscribersMap = new Map();
    const linkedOrderIdsMap = shipment?.jobs?.reduce((acc, item) => {
      acc.set(item?.id, item);
      return acc;
    }, new Map());
    shipment?.subscribers?.forEach((item) => {
      const mapId =
        item?.customerId ||
        item?.moveCoordinatorId ||
        item?.managerId ||
        item?.consultantId ||
        item?.id ||
        item?.userId;
      subscribersMap?.set(mapId, item);
    });

    fetchedSubscribers?.forEach((item: ISubscriber) => {
      const mapId =
        item?.customerId ||
        item?.moveCoordinatorId ||
        item?.managerId ||
        item?.consultantId ||
        item?.id ||
        item?.userId;
      subscribersMap?.set(mapId, item);
    });
    const linkedOrderEntities = getSubscribersLinkingToOrders(
      shipment?.jobs || [],
      subscribersMap,
      shipment?.customersToShipment || []
    );

    const combineData = [
      ...(fetchedSubscribers || []),
      ...(shipment?.subscribers || []),
      ...(linkedOrderEntities || []),
    ].filter((i) => !!i);

    const result = combineData?.filter((i) => !!i);

    return result;
  }, [fetchedSubscribers, shipment?.subscribers, shipment?.jobs]);

  const shipmentOrders = useMemo(
    () => [
      { label: SHOW_ALL_ORDER_ID, value: SHOW_ALL_ORDER_ID },
      ...(shipment?.jobs?.map((job) => ({
        label: job?.reference,
        value: job?.reference,
      })) || []),
      ...(shipment?.customersToShipment?.map((customerToShipment) => ({
        label: customerToShipment?.order,
        value: customerToShipment?.order,
      })) || []),
    ],
    [shipment?.jobs, shipment?.customersToShipment]
  );

  const filteredData = useMemo(() => {
    const filtered = subscribers?.filter((subscriber) => {
      const matchesSearch =
        subscriber.fullName?.toLowerCase().includes(searchQuery.toLowerCase()) ||
        subscriber.email?.toLowerCase().includes(searchQuery.toLowerCase()) ||
        subscriber.mobile?.toLowerCase().includes(searchQuery.toLowerCase());

      const matchesOrder =
        selectedOrder?.value === SHOW_ALL_ORDER_ID ||
        (subscriber.jobReference &&
          subscriber.jobReference.toString() === String(selectedOrder?.value));

      return matchesSearch && matchesOrder;
    });

    return _.uniqBy(filtered, "id"); // 👈 Removes duplicates based on `id`
  }, [searchQuery, selectedOrder, subscribers]);

  const handleSelectAllClick = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.checked) {
      setSelectedRowList?.(filteredData);

      return;
    }
    setSelectedRowList?.([]);
  };

  const handleCurrentPage = (page: number) => {
    setPage?.(page);
    setSelectedRowList?.([]);
  };

  const handleOrderSelect = (order: any) => {
    setSelectedOrder(order);
    setPage?.(0);
  };

  const renderEditRowButton = (rowId: number, params: any) => {
    return (
      <Tooltip data-cy="action-edit" title={translate("edit")} placement="top">
        <IconButton
          size="small"
          onClick={(e) => {
            e.stopPropagation();

            console.log(params);
            formValueRef.current = params;
            setProcessedItem(params);
            setIsNewSubscriberModalOpen(true);
          }}
        >
          <img src={EditIcon} alt="Edit Icon" style={{ width: 20, height: 20 }} />
        </IconButton>
      </Tooltip>
    );
  };

  const renderCommunicationRowButton = (rowId: number, params: any) => {
    if (!shipment?.id) return null;

    return (
      <Tooltip data-cy="action-communication" title={translate("communication")} placement="top">
        <IconButton
          size="small"
          onClick={(e) => {
            e.stopPropagation();
            const newList = [params] as any;
            setProcessedItem(newList);
            setIsOpenModalSendCommunication(true);
          }}
        >
          <img src={SendMessageIcon} alt="Message Icon" style={{ width: 20, height: 20 }} />
        </IconButton>
      </Tooltip>
    );
  };

  const renderDeleteRowButton = (rowId: number, params: any) => {
    if (
      subscribersDirectFromOrder?.filter(
        (item) =>
          item?.id === params?.customerId ||
          item?.id === params?.moveCoordinatorId ||
          item?.id === params?.userId ||
          item?.id === params?.managerId ||
          item?.id === params?.bookingAgentId ||
          item?.id === params?.consultantId
      )?.length > 0
    )
      return null;

    return (
      <Tooltip data-cy="action-delete" title={translate("delete")} placement="top">
        <IconButton
          size="small"
          style={{
            visibility: isSelected(params?.id) ? "visible" : "hidden",
          }}
          onClick={(e) => {
            e.stopPropagation();
            setIsShowConfirmDelete(true);
            setProcessedItem(params);
            formValueRef.current = params;
          }}
        >
          <img src={DeleteIcon} alt="Delete Icon" style={{ width: 20, height: 20 }} />
        </IconButton>
      </Tooltip>
    );
  };

  const renderSelectRowAll = () => {
    return (
      <TextButton
        label={selectedRowList?.length === 0 ? translate("selectAll") : translate("deSelectAll")}
        onClickHandler={() => {
          if (selectedRowList?.length === 0) {
            handleSelectAllClick({ target: { checked: true } } as any);
          } else {
            handleSelectAllClick({ target: { checked: false } } as any);
          }
        }}
      />
    );
  };

  const renderSubscriber = () => {
    return (
      <div
        style={{
          minWidth: "166px",
          textAlign: "right",
        }}
      >
        <Button
          style={{
            padding: "10px 20px 10px 16px",
          }}
          onClick={() => setIsNewSubscriberModalOpen(true)}
          startIcon={<FaPlus style={{ height: 14, width: 14 }} />}
          customColor={Color.SECONDARY_DARK}
        >
          <span
            style={{
              fontFamily: "Manrope",
              fontWeight: "600",
              fontSize: "14px",
              lineHeight: "20px",
              letterSpacing: "0.1px",
              textAlign: "center",
              verticalAlign: "middle",
              color: "#FFFFFF",
            }}
          >
            {translate("newSubscriber")}
          </span>
        </Button>
      </div>
    );
  };

  const renderNotifyVia = () => {
    if ((selectedRowList?.length ?? 0) > 0 && shipment?.id) {
      return (
        <div
          style={{
            minWidth: "150px",
            textAlign: "right",
          }}
        >
          <Button
            style={{
              padding: "10px 20px 10px 16px",
            }}
            customColor={Color.SECONDARY_DARK_OUTLINED}
            onClick={() => {
              const newList = [];
              for (const element of selectedRowIds as any[]) {
                const findObject = filteredData.find((item) => item.id === element);
                if (findObject) {
                  newList?.push(findObject);
                }
              }
              setProcessedItem(newList as any);
              setIsOpenModalSendCommunication(true);
            }}
          >
            <div
              className="d-flex justify-content-between align-items-center"
              style={{
                gap: "8px",
              }}
            >
              <ReactSVG src={ACTION_COMMUNICATION_ICON} />
              <span>{translate("notifyUsers")}</span>
            </div>
          </Button>
        </div>
      );
    }
  };

  const generalActions: GeneralActions = {
    orderBy: {
      left: ["handleSearch", "renderSelectRowAll"],
      right: ["renderNotifyVia", "renderSubscriber"],
    },
    handleSearch: {
      onSearch: (filters: Searches) => {
        const value = Object.values(filters?.[0] || {})?.[0] || "";
        setSearchQuery(value);
      },
    },
    renderSelectRowAll: renderSelectRowAll(),
    renderSubscriber: renderSubscriber(),
    renderNotifyVia: renderNotifyVia(),
  };

  const selectedRowIds: number[] = useMemo(() => {
    return (
      selectedRowList
        ?.map((item) => {
          if (typeof item === "number") return item;
          if (item && typeof item.id === "number") return item.id;
          return undefined;
        })
        .filter((id): id is number => typeof id === "number") || []
    );
  }, [selectedRowList]);

  useEffect(() => {
    setNewSubscriberFormErrors([]);
  }, [isNewSubscriberModalOpen]);

  useEffect(() => {
    if (isComponentPristine) {
      setIsComponentPristine(false);
    }
  }, [searchQuery, selectedOrder?.value, sorting, page]);

  const textFromShipmentForm = useMemo(() => {
    if (shipment?.id && shipment.statusShipment?.toLowerCase() !== ShipmentTrackingStatus.DRAFT) {
      return translate("update");
    }

    return translate("create");
  }, [shipment?.id, shipment?.statusShipment]);

  return (
    <div>
      <div className="way-bill" style={{ display: "flex", width: "100%", padding: " 24px" }}>
        {filteredData?.length < 1 &&
        !searchQuery &&
        selectedOrder?.value === SHOW_ALL_ORDER_ID &&
        shipmentOrders?.length < 2 &&
        !isFetchingSubscribers ? (
          <EmptySection title={translate("noSubscriberAdded")} />
        ) : (
          <>
            {/* Refine By Order Drawer */}
            <div
              style={{
                position: "sticky",
                top: 80,
                border: `1px solid ${colors.gray200}`,
                borderRadius: "12px",
                width: "207px",
                padding: "16px 12px",
                height: componentHeight,
                overflowY: "auto",
                flexShrink: 0,
                background: colors.gray25,
              }}
            >
              <div
                style={{
                  borderRadius: "8px",
                }}
              >
                <StyledDrawerTitle>{translate("refineByOrder")}</StyledDrawerTitle>
                <div
                  style={{
                    marginTop: "12px",
                    backgroundColor: "#FFFFFF",
                    borderRadius: "8px",
                    overflow: "hidden",
                  }}
                >
                  {shipmentOrders?.map((order) => (
                    <div key={order?.value}>
                      <StyledListItemButton
                        onClick={() => handleOrderSelect(order)}
                        className={selectedOrder?.value === order?.value ? "selected" : ""}
                      >
                        <div>{order?.label}</div>
                      </StyledListItemButton>
                    </div>
                  ))}
                </div>
              </div>
            </div>
            {/* Main content */}
            <ContentContainer
              style={{
                width: "80%",
              }}
            >
              <ContentWrapper
                style={{
                  width: "100%",
                }}
              >
                <div
                  style={{ display: "flex", flexDirection: "column", gap: "16px", width: "100%" }}
                >
                  <div className={classes.notificationWrapper} key={JSON.stringify(selectedRowIds)}>
                    <ShipeeziNewGrid
                      columns={columns}
                      data={filteredData || []}
                      totalItems={total}
                      loadingData={isFetchingSubscribers || isAdding || isUpdating || isDeleting}
                      namePage={translate("notifications")}
                      emptyData={translate("noInformationToBeShown")}
                      pageSize={pageSize}
                      pageSizeList={pageSizeOptions}
                      onChangePageSize={(pageSize: number) => {
                        setPage?.(pageSize);
                        setSelectedRowList?.([]);
                      }}
                      currentPage={page}
                      onNextPage={handleCurrentPage}
                      onPreviousPage={handleCurrentPage}
                      onGoToPage={handleCurrentPage}
                      selecteds={selectedRowIds}
                      handleSelect={(row: any) => {
                        const filteredList = filteredData?.filter((item: ISubscriber) =>
                          row?.includes(item.id)
                        );
                        setSelectedRowList?.(filteredList);
                      }}
                      onSorting={handleSorting}
                      positionActionsColumn="right"
                      showColumnChooser={false}
                      stickyActions
                      generalActions={generalActions}
                      rowActionsExtra={[
                        {
                          title: translate("edit"),
                          key: "edit",
                          buttonAndAction: renderEditRowButton,
                        },

                        {
                          title: translate("communication"),
                          key: "communication",
                          buttonAndAction: renderCommunicationRowButton,
                        },
                        {
                          title: translate("delete"),
                          key: "delete",
                          buttonAndAction: renderDeleteRowButton,
                        },
                      ]}
                    />
                  </div>
                </div>
              </ContentWrapper>
            </ContentContainer>
          </>
        )}

        {/* New Subscriber Modal */}
        <Modal
          open={isNewSubscriberModalOpen}
          onClose={() => {
            setIsNewSubscriberModalOpen(false);
          }}
          aria-labelledby="new-subscriber-modal"
          disableRestoreFocus
          disablePortal={false}
          sx={{
            "& .MuiPaper-rounded": {
              borderRadius: "12px",
            },
          }}
        >
          <React.Fragment>
            <Paper
              sx={{
                position: "absolute",
                top: "50%",
                left: "50%",
                padding: "24px 24px 16px 24px",
                transform: "translate(-50%, -50%)",
                width: "30vw",
                outline: "none",
                maxHeight: "90vh",
                borderRadius: "12px 12px 0 0",
                display: "flex",
                flexDirection: "column",
              }}
            >
              {/* Header */}
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <div
                  style={{
                    color: colors.gray600,
                    fontFamily: "Manrope",
                    fontSize: "22px",
                    fontStyle: "normal",
                    fontWeight: "700",
                    lineHeight: "28px",
                  }}
                >
                  {processedItem?.id ? translate("editSubscriber") : translate("newSubscriber")}
                </div>
                <IconButton
                  onClick={() => {
                    setIsNewSubscriberModalOpen(false);
                    setProcessedItem(null);
                    formValueRef.current = {};
                  }}
                  size="small"
                  sx={{ color: colors.gray600 }}
                >
                  <FiX size={20} />
                </IconButton>
              </Box>

              {/* Content */}
              <Box sx={{ flexGrow: 1, overflowY: "auto", py: "32px" }}>
                {isNewSubscriberModalOpen && (
                  <ShipmentNewSubscriberForm
                    values={
                      processedItem ||
                      (selectedOrder?.value !== SHOW_ALL_ORDER_ID && {
                        jobReference: selectedOrder?.value,
                      })
                    }
                    onChange={(value) => {
                      handleFormChange(value);
                    }}
                    errors={newSubscriberFormErrors}
                  />
                )}
              </Box>

              {/* Footer */}
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "flex-end",
                  gap: 2,
                }}
              >
                <Button
                  customColor={Color.DEFAULT}
                  onClick={() => {
                    setIsNewSubscriberModalOpen(false);
                    setProcessedItem(null);

                    formValueRef.current = {};
                  }}
                >
                  {translate("cancel")}
                </Button>
                <Button
                  customColor={Color.SUCCESS}
                  onClick={
                    processedItem && processedItem?.mode !== SubscriberPatchModeEnum.ClientSnapShot
                      ? handleEditSubscriber
                      : handleAddSubscriber
                  }
                >
                  {processedItem ? translate("update") : translate("add")}
                </Button>
              </Box>
            </Paper>
          </React.Fragment>
        </Modal>
        {isShowConfirmDelete && (
          <ConfirmDeleteModal
            open={isShowConfirmDelete}
            onClose={() => {
              setProcessedItem(null);
              setIsShowConfirmDelete(false);
            }}
            onSave={() => {
              removeSubscriber(processedItem!);
              setIsShowConfirmDelete(false);
            }}
            modalTitle={`${translate("deleteSubscriber")}?`}
            contentTitle={translate("whenYouDeleteANotification")}
            subContentTile={translate("wouldYouLikeToProceed")}
            saveButtonTitle={translate("yesDelete")}
          />
        )}

        {isOpenModalSendCommunication && (
          <div>
            <ModalSendCommunication
              id={shipment?.id || 0}
              dataList={processedItem}
              label={translate("notifyVia")}
              isOpen={isOpenModalSendCommunication}
              onClose={() => {
                setIsOpenModalSendCommunication(false);
              }}
              onSubmit={() => {
                setSelectedRowList?.([]);
                // setIsOpenModalSendCommunication(false);
              }}
            />
          </div>
        )}
      </div>
      <div
        style={{
          margin: "8px 0px 0px 0px",
          color: "red",
          borderTop: `1px solid ${colors.gray200}`,
        }}
      />
      <Grid
        item
        xs={12}
        container
        alignItems="center"
        justifyContent={
          shipment?.id && props?.permission && props?.permission?.delete
            ? "space-between"
            : "flex-end"
        }
        style={{
          paddingLeft: "24px",
          paddingRight: "24px",
          margin: "16px 0px",
        }}
      >
        {shipment?.id && props?.permission && props?.permission?.delete && (
          <Button
            disabled={isLoading}
            customColor={Color.ERROR}
            startIcon={<FiTrash2 size={12} color="#FFFFFF" />}
            onClick={() => {
              setHasUnsavedChanges(false);
              props?.setOpenConfirmationDeleteModal?.(true);
            }}
          >
            {translate("cancelShipment")}
          </Button>
        )}
        <ActionButtons
          textSavePublish={textFromShipmentForm}
          customColorSavePublish={Color.SECONDARY_DARK}
          customColorSave={shipment?.marineTrafficId ? Color.SUCCESS : Color.SUCCESS_OUTLINED}
          customColorCancel={Color.TEXT_INFO}
          textSave={shipment?.marineTrafficId ? translate("update") : translate("saveAsDraft")}
          dataCySavePublish="save-and-subscribe-button"
          dataCySave="save-button"
          savePublishDisabled={isLoading || props?.isSaving || props?.publishDisabled}
          cancelDisabled={isLoading || props?.isSaving}
          saveDisabled={isLoading || props?.isSaving}
          onCancel={() => {
            if (props?.hasBeenSaved && hasUnsavedChanges) {
              setHasUnsavedChanges(false);
            }
            history.push(PRIVATE_ROUTES.SHIPMENTS);
          }}
          onSave={props?.onSave}
          onSavePublish={props?.onSaveAndSubscribe}
        />
      </Grid>
    </div>
  );
};
